export const TYPE_TAB = 0;
export const DATA_TAB = 1;
export const STYLE_TAB = 2;
